import React, { Component } from 'react';
import Api from './api';
import QuestionPresenter from "./QuestionPresenter";
import ContentBox from './ContentBox';
import QuizPage from './QuizPage';
import CodeMarkdown from './CodeMarkdown';
import LoadingPage from './LoadingPage';
import { getAppContext } from './AppContext';
const {default: PQueue} = require('p-queue');

let savedInfos = {
    tobias: {
      firstName: 'Tobias',
      lastName: 'Anhalt',
      email: 'tobias@mythli.net',
      phone: '+4917632630391'
    },
    shashank: {
      firstName: 'Shashank',
      lastName: 'Agarwal',
      email: 'shashank+quiz@web-bee.org',
      linkedIn: "https://www.linkedin.com/in/theshashankagarwal/",
      phone: '+375339147769'
    },
    default: {
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
    }
};

const campaignNames = [
  'headhunter',
];

const CampaignFields = {
    headhunter: ({$Headhunter, setPersonalInfo}) => {
        return (
            <div className="form-group">
                <label htmlFor="headhunterInput">Headhunter Cv</label>
                <input
                    type="text"
                    className="form-control"
                    id="headhunterInput"
                    placeholder="Enter Linkedin profile"
                    value={$Headhunter}
                    onChange={(value) => setPersonalInfo('$Headhunter', value.target.value)}
                />
            </div>
        );
    }
};

const InfoPage = ({Title, Description, start}) => {
    return (
        <ContentBox>
            <div className="block">
                <CodeMarkdown source={Description} />
            </div>

            <div className="block">
                <button className="btn btn-primary btn-lg" onClick={start}>Do the test</button>
            </div>
        </ContentBox>
    );
};

const SuccessPage =({successText}) => {
    return (
        <ContentBox>
            <CodeMarkdown source={successText} />
        </ContentBox>
    );
};

const CategoryPage = ({categoryCount,categoriesDone,category, start}) => {
    let categoryNr = categoriesDone,
        title = `${categoryNr} / ${categoryCount} - ${category.Name}`;

    return (
        <ContentBox>
            <div className="block">
                <h1>{title}</h1>
                <CodeMarkdown source={category.Description} />
            </div>
            <div className="block">
                <button
                    className="btn btn-primary btn-lg"
                    onClick={() => start(category.id)}>
                    Start
                </button>
            </div>
        </ContentBox>
    );
};

const Required = () => {
    return <span className="required-field">*</span>
}

const PersonalInfoPage = ({campaign, firstName, lastName, email, phone, linkedIn, setPersonalInfo, start, ...other}) =>  {
    const onSubmit = (e) => {
      start();
      e.preventDefault();
    };

    let CampaignComponent = campaign ? CampaignFields[campaign] : null;

    return (
        <ContentBox>
            <h1>Contact information</h1>

            <form onSubmit={onSubmit} className="block">

                <div className="form-row">
                    <div className="form-group col-md-6">
                        <label htmlFor="inputFirstName">First Name<Required /></label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputFirstName"
                            placeholder="First Name"
                            value={firstName}
                            onChange={(value) => setPersonalInfo('firstName', value.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group col-md-6">
                        <label htmlFor="inputLastName">Last Name<Required /></label>
                        <input
                            type="text"
                            className="form-control"
                            id="inputLastName"
                            placeholder="Last Name"
                            value={lastName}
                            onChange={(value) => setPersonalInfo('lastName', value.target.value)}
                            required
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="emailInput">Email address<Required /></label>
                    <input
                        type="email"
                        className="form-control"
                        id="emailInput"
                        placeholder="Enter email"
                        value={email}
                        onChange={(value) => setPersonalInfo('email', value.target.value)}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="linkedinInput">Linkedin Profile<Required /></label>
                    <input
                        type="text"
                        className="form-control"
                        id="linkedinInput"
                        placeholder="Enter Linkedin profile"
                        value={linkedIn}
                        onChange={(value) => setPersonalInfo('linkedIn', value.target.value)}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="phoneInput">Mobile phone<Required /></label>
                    <input
                        className="form-control"
                        id="phoneInput"
                        placeholder="Enter mobile phone"
                        value={phone}
                        onChange={(value) => setPersonalInfo('phone', value.target.value)}
                        required
                    />
                    <div className='alert alert-danger mt-2'>
                        <p>We will call you on WhatsApp.</p>
                        <ul>
                            <li>Please double check this phone number is your WhatsApp number</li>
                            <li>Please add the country code prefix:<br />+91 for India, +49 for Germany, +375 for Belarus +7 for Russia and so on..</li>
                            <li>Example: +91 123456789</li>
                        </ul>
                    </div>
                </div>

                {CampaignComponent && <CampaignComponent setPersonalInfo={setPersonalInfo} {...other} />}

                <div className="block">
                    <button type="submit" className="btn btn-primary">Save</button>
                </div>
            </form>
        </ContentBox>
    );
};

class QuizContainer extends Component {
    static contextType = getAppContext();
    
    state = {
        quizProgress: null,
        personalInfo: null,
        isLoading: false,
        questionState: {},
        startTime: null,
        categoriesStarted: [],
        campaign: null
    };

    questionPresenter = null;

    constructor() {
        super();
        this.queue = new PQueue({concurrency: 1});
    }

    componentDidMount() {
        if (this.context.progress?.personalInfo) {
            this.setState(this.context.progress, () => this.initQuiz());
        }
    }

    updateState(state, func) {
        this.setState(state, (...args) => {
            func && func(...args);
            this.context.updateUserProgress(this.state)
        });
    }

    loading = (isLoading = true) => {
        this.updateState({isLoading});
    };

    setQuestionState = (value) => {
        this.updateState({ questionState: { ...this.state.questionState, ...value }});
    };

    cacheRecording = async (blob, id) => {
        await this.getApi().cacheRecording(blob, id)
    };

    getApi = () => {
        return new Api(this.props.backendApiUrl);
    };

    submitQuestion = async () => {
        let {question} = this.questionPresenter.getCurrentData(),
            value = this.state.questionState.value;

        console.log('question '+question.id+' submitted', this.state);

        let answerValue = {};
        switch(question.Type) {
            case 'Choice':
                answerValue.choiceAnswers = value ? [value] : null;
                break;
            case 'Multiple Choice':
                answerValue.choiceAnswers = value;
                break;
            case 'voice':
                answerValue.recordingId = value;
                break;
            default:
                answerValue.textAnswer = value ?? question.Inhalt ?? "";
                break;
        }

        let takenQuizId = this.state.quizProgress.takenQuiz.id;

        // this.queue.add(() => this.getApi().answer({
        //     questionId: question.id,
        //     takenQuizId,
        //     ...answerValue
        // }));

        await this.queue.onIdle();
        const answer = await this.getApi().answer({
            questionId: question.id,
            takenQuizId,
            ...answerValue
        });

        let quizProgress = {
            ...this.state.quizProgress,
            givenAnswers: [...this.state.quizProgress.givenAnswers, answer]
        };

        let qp = new QuestionPresenter(this.props.quiz, quizProgress);
        let nextQuestion = qp.getCurrentData().question;

        console.log('next question', nextQuestion);

        if(!nextQuestion) {
            this.queue.add(() => this.getApi().finish(takenQuizId));
            await this.queue.onIdle();
        }

        console.log('quizProgress', quizProgress);

        this.updateState({
            quizProgress,
            questionState: !nextQuestion ? {} : { questionId: nextQuestion.id },
            startTime: Date.now()
        });
    };

    recordPersonalInfo = () => {
        let infoName = window.location.hash.replace('#', ''),
            defaultInfo = savedInfos.default;

        if(campaignNames.indexOf(infoName) > -1) {
            return this.setState({
                personalInfo: defaultInfo,
                campaign: infoName
            });
        }

        let info = savedInfos[infoName];
        info = info ? info : savedInfos.default;

        this.setState({ personalInfo: info });
    };

    initQuiz = async () => {
        this.loading();
        try {
            let quizProgress = await this.getApi().initQuiz({
                ...this.state.personalInfo,
                quizName: this.props.quiz.quiz.Name,
                quizId: this.props.quiz.quiz.id
            });

            console.log('initialized quiz', quizProgress);

            this.setState({
                quizProgress,
                isLoading: false,
                startTime: this.state.startTime ? new Date(this.state.startTime) : new Date(),
            }, this.ensureQuestionStateIsValid);

        } catch (e) {
            this.setState({ isLoading: false });
        }
    };


    ensureQuestionStateIsValid = () => {
        if (!this.questionPresenter) {
            return;
        }

        const question = this.questionPresenter.getCurrentData().question;
        if (!question) {
            return;
        }

        if (question.id !== this.state.questionState.questionId) {
            this.updateState({
                startTime: new Date(),
                questionState: { questionId: question.id },
            })
        }
    }


    setPersonalInfo = (name, value) => {
        this.setState({
            personalInfo: {
                ...this.state.personalInfo,
                [name]: value
            }
        })
    };

    setQuestionPresenter(state = this.state) {
        this.questionPresenter =  state.quizProgress
            ? new QuestionPresenter(this.props.quiz, state.quizProgress) :
            null;
    }

    startCategory = (categoryId) => {
        this.updateState({
            categoriesStarted: [...this.state.categoriesStarted, categoryId]
        });
    }

    componentWillUpdate(p, nextState) {
        if(nextState.quizProgress === this.state.quizProgress) {
            return;
        }

        this.setQuestionPresenter(nextState);
    }

    render() {
        console.log('1 XXX', this.state);

        if(this.state.isLoading) {
            return <LoadingPage />
        }

        if(!this.state.personalInfo) {
            console.log('2 InfoPage XXX');

            return <InfoPage
                className="loading-content-box"
                start={this.recordPersonalInfo}
                {...this.props.quiz.quiz}
            />
        }

        if(!this.state.quizProgress) {
            console.log('3 PersonalInfoPage XXX');

            return <PersonalInfoPage
                className="loading-content-box"
                start={this.initQuiz}
                setPersonalInfo={this.setPersonalInfo}
                {...this.state.personalInfo}
                campaign={this.state.campaign}
            />
        }

        console.log('4 Get Data XXX');

        let {question, category, categoriesDone} = this.questionPresenter.getCurrentData();

        console.log('4.1 Got Data XXX', question, category);

        if(question) {
            if(category.description && category.description.length && this.state.categoriesStarted.indexOf(category.id) < 0) {
                console.log('4 CategoryPage XXX');

                return <CategoryPage
                    categoryCount={this.props.quiz.categories.length}
                    categoriesDone={categoriesDone.length}
                    category={category}
                    start={this.startCategory}
                />
            }

            console.log('5 QuizPage XXX');

            return <QuizPage
                startTime={this.state.startTime}
                question={question}
                setQuestionState={this.setQuestionState}
                questionState={this.state.questionState}
                submitQuestion={this.submitQuestion}
                cacheRecording={this.cacheRecording}
            />
        }

        console.log('6 Success Page');

        return <SuccessPage
            successText={this.props.quiz.quiz.successText}
        />
    }
}

export default QuizContainer;
